import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core'

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'search-bar',
  styleUrls: ['../../css/search-bar.css'],
  templateUrl: './search-bar.component.html'
})
export class SearchBarComponent {
  @Input() public inputText: string
  @Input() public placeholder: string
  @Output() public inputTextChange = new EventEmitter()
}
